import { type AxiosRequestConfig } from 'axios'

const deleteUserLanguage = (id: string): AxiosRequestConfig => {
  return {
    method: 'DELETE',
    url: '/user/info/languages/item',
    params: {
      id
    }
  }
}

export { deleteUserLanguage }
